import { ShellSwitcher } from './ShellSwitcher';
import type { Shell } from '../shells/types';

interface HeaderProps {
  showAskAnother: boolean;
  onAskAnother: () => void;
  shell: Shell;
  onShellChange: (s: Shell) => void;
}

// Brand-mark + title shown in both states so the page reads as fully styled
// on first paint. The "Ask another" affordance only appears once a query is
// in flight; the shell switcher is always visible so the layout choice is
// reversible.
export function Header({ showAskAnother, onAskAnother, shell, onShellChange }: HeaderProps) {
  return (
    <header className={`header ${showAskAnother ? 'header--asking' : 'header--blank'}`}>
      <div className="header-inner">
        <div className="brand brand--compact">
          <div className="brand-mark">HDW</div>
          <div className="brand-title">HRSA Data Warehouse Search</div>
        </div>
        <div className="header-actions">
          <ShellSwitcher shell={shell} onChange={onShellChange} />
          {showAskAnother && (
            <button onClick={onAskAnother} className="btn-secondary">
              ↻ Ask another
            </button>
          )}
          <a
            href="https://data.hrsa.gov"
            target="_blank"
            rel="noopener noreferrer"
            className="link-muted"
          >
            data.hrsa.gov ↗
          </a>
        </div>
      </div>
    </header>
  );
}
